import { useCookies } from 'vue3-cookies'
import store from '@/components/store/store'

const cookies = useCookies(['token'])
export const apiClient = async (path, data = {}) => {
  const token = cookies.cookies.get(['token'])
  try {
    const response = await fetch('https://lk.lineon.me/api/' + path, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(data)
    });

    if (response.status === 401) {
      await store.dispatch('auth/revokeUser');
      // Можно дополнительно выбросить ошибку или вернуть
      return;
    }

    // Дальше обычная обработка ответа
    return await response.json();

  } catch (err) {
    // Здесь только сетевые ошибки (например, нет связи с сервером)
    //await store.dispatch('auth/revokeUser');
  }
}